import { render, staticRenderFns } from "./orderItems.vue?vue&type=template&id=003bb85a&scoped=true&"
import script from "./orderItems.vue?vue&type=script&lang=tsx&"
export * from "./orderItems.vue?vue&type=script&lang=tsx&"
import style0 from "./orderItems.vue?vue&type=style&index=0&id=003bb85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003bb85a",
  null
  
)

export default component.exports